<div class="integration-options">

  <div class="integration-loading" *ngIf="loading()">
    <span class="loading-dot pulse-dot"></span>
    <span class="loading-text">CARGANDO PROYECTOS…</span>
  </div>

  <p class="integration-error" *ngIf="!loading() && errorMessage()">
    {{ errorMessage() }}
  </p>

  <ng-container *ngIf="!loading() && !errorMessage()">

    <div class="integration-field" *ngIf="projects().length > 0; else noProjects">
      <label class="field-label" for="jira-project">PROYECTO</label>
      <select id="jira-project"
              class="field-select"
              [(ngModel)]="selectedProjectKey"
              (ngModelChange)="onProjectChange()">
        <option *ngFor="let p of projects()" [value]="p.key">
          {{ p.key }} — {{ p.name }}
        </option>
      </select>
    </div>

    <div class="integration-field" *ngIf="availableIssueTypes.length > 0">
      <label class="field-label" for="jira-issue-type">TIPO DE ISSUE</label>
      <select id="jira-issue-type"
              class="field-select"
              [(ngModel)]="selectedIssueTypeName"
              (ngModelChange)="onIssueTypeChange()">
        <option *ngFor="let t of availableIssueTypes" [value]="t.name">
          {{ t.name }}<span *ngIf="t.subtask"> (subtask)</span>
        </option>
      </select>
    </div>

    <div class="integration-field" *ngIf="projects().length > 0">
      <label class="field-label" for="jira-prefix">
        PREFIX SUMMARY <span class="field-hint">(opcional)</span>
      </label>
      <input id="jira-prefix"
             type="text"
             class="field-input"
             placeholder="ej. [EST-2026Q2]"
             [(ngModel)]="summaryPrefix"
             (ngModelChange)="onPrefixChange()"
             maxlength="60" />
    </div>

    <ng-template #noProjects>
      <p class="integration-empty">
        Sin proyectos accesibles para tu cuenta.
      </p>
    </ng-template>

  </ng-container>
</div>
